import { type TENANT } from '../../../tenant/tenantTypes'

import { EXPERIMENT_OWN_BRANDS_OVERLAY_PRODUCTS_MAP } from './ExperimentOwnBrandsOverlayConsts'

export const isProductInOwnBrandsProductsMap = (
  upid: string,
  tenant: TENANT,
): boolean => {
  const mapForTenant: Record<string, string> | undefined =
    EXPERIMENT_OWN_BRANDS_OVERLAY_PRODUCTS_MAP[tenant]

  return Boolean(mapForTenant && Object.keys(mapForTenant).includes(upid))
}
